import { OrderTypeEnum } from "src/enums/order.enum";

const ORDER_TYPE_OPTIONS: { value: OrderTypeEnum | null; label: string }[] = [
  { value: null, label: "All" },
  { value: OrderTypeEnum.DINE_IN, label: "Dine In" },
  { value: OrderTypeEnum.PICK_UP, label: "Pick Up" },
  { value: OrderTypeEnum.DELIVERY, label: "Delivery" },
  { value: OrderTypeEnum.ENTERPRISE, label: "Enterprise" },
];

interface OrderTypeFilterButtonsProps {
  value: OrderTypeEnum | null;
  onChange: (type: OrderTypeEnum | null) => void;
}

const OrderTypeFilterButtons = ({ value, onChange }: OrderTypeFilterButtonsProps) => (
  <div className="flex flex-wrap items-center gap-1 rounded-lg border border-[#F1F1F2] p-0.5 bg-white w-full md:w-fit">
    {ORDER_TYPE_OPTIONS.map(({ value: optionValue, label }) => {
      const isActive = value === optionValue;
      return (
        <button
          key={optionValue ?? "all"}
          type="button"
          onClick={() => onChange(optionValue)}
          className={`h-[38px] px-3 text-xs font-medium rounded-md transition-all outline-none focus:ring-0 ${
            isActive
              ? "bg-[#FD7657] text-white shadow-sm"
              : "bg-white text-[#6b7280] hover:bg-[#FEF5F4] hover:text-[#FD7657]"
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default OrderTypeFilterButtons;
